// extracted by mini-css-extract-plugin
export default {"container":"Zaa-z","productName":"_aa-z","price":"aba-z","dimensions":"bba-z"};